import Box from "@mui/material/Box";
import { Stack, Typography } from "@mui/material";
import AddButton from "./buttons/AddButton";
import CancelLockupProposalTable from "./tables/CancelLockupProposalTable";
import ProposalTabs from "../../../shared/ProposalTabs";
import ProceedTable from "./tables/ProceedTable";

export default function CancelLockupOwnershipProposalPage() {
  return (
    <Box>
      <Stack
        direction="row"
        sx={{ width: "100%", marginBottom: 2, alignItems: "center" }}
      >
        <Typography variant="h5" sx={{ flexGrow: 1 }}>
          Cancel Lockup Proposal
        </Typography>
        <AddButton />
      </Stack>
      <ProposalTabs
        processingTab={<CancelLockupProposalTable />}
        proceedTab={<ProceedTable />}
      />
    </Box>
  );
}
